import styled from "styled-components";

const HorizontalDivider = styled.div`
    width: 80%;
    height: 3px;
    background-color: rgb(180,180,180);
    margin-top: 5px;
    margin-bottom: 5px;
`

export default HorizontalDivider;